/**
 * Wraps a promise as an angular HTTP promise with `success` and `error` methods
 * that extract the HTTP response data.
 *
 * Adapted from angular source: https://github.com/angular/angular.js/blob/master/rhino/src/ng/http.js#L957
 * To proxy known http promise methods.
 *
 * (Extracted to its own file to aide in creating mock responses in testing.)
 */
export default function wrapHttpPromise(promise) {
  promise.success = function (fn) {
    promise.then(function (response) {
      fn(response.data, response.status, response.headers, response.config);
    });
    return promise;
  };

  promise.error = function (fn) {
    promise.then(null, function (response) {
      if (_.has(response, 'config')) {
        fn(response.data, response.status, response.headers, response.config);
      } else {
        // May be an error from rnRegistry, not a response object.
        fn(response, null, null, response.config);
      }
    });
    return promise;
  };

  return promise;
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/core/http/http.promise.js